<ul *ngIf="items.length">
  <li *ngFor="let item of items">
  {{ item.name }}
  <app-tree-view *ngIf="item[key]?.length" [key]="key" [data]="item[key]"></app-tree-view>
  </li>
</ul>
